module.exports = __webpack_public_path__ + "img/1494931261.a564328c.jpg";